import { ADMIN_ROLES } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

import { AuthController } from '../auth-controller';

export class PartnerProductsController extends AuthController {
  public pageId = 'partnerProducts';
  public path = '/admn/partnerOverview/partner-products';
  public routeName = 'partnerProducts';
  public bundles = [];
  public pageTitle = 'controllers.partnerProducts';
  public isAdminView = true;
  public accessRoles = [
    ADMIN_ROLES.INTERNAL_COLLECTIONS_MANAGER,
    ADMIN_ROLES.INTERNAL_ADMIN,
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
  ];

  public readOnlyAccessRoles = [
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
  ];

  public component = codeSplit(
    () => import(/* webpackChunkName: "partnerProducts" */ '../../views/admin/partner-products'),
  );
  public exact = true;
}
